import { Flex } from "@chakra-ui/react";
import React from "react";

import { CompanyAutocompleteSelect } from "@/common/components/Autocomplete/CompanyAutocompleteSelect";
import { FeatureAutocompleteSelect } from "@/common/components/Autocomplete/FeatureAutocompleteSelect";
import { SatisfactionFilter } from "@/common/components/SatisfactionFilter";
import { SegmentPicker } from "@/common/components/SegmentPicker";
import { useFeedbackTableState } from "@/feedback/hooks/useFeedbackTableState";

export const FeedbackFilters = ({
  canFilterBySegment = true,
  canFilterByFeature = true,
  canFilterByCompany = true,
}: {
  canFilterBySegment?: boolean;
  canFilterByFeature?: boolean;
  canFilterByCompany?: boolean;
}) => {
  const {
    satisfactionFilter,
    onSatisfactionFilterChange,
    featureFilter,
    onFeatureFilterChange,
    companyFilter,
    onCompanyFilterChange,
    segmentFilter,
    onSegmentFilterChange,
  } = useFeedbackTableState();

  return (
    <Flex align="center" gap={2} wrap="wrap">
      <SatisfactionFilter
        size="sm"
        value={satisfactionFilter}
        onChange={onSatisfactionFilterChange}
      />
      {canFilterByFeature && (
        <FeatureAutocompleteSelect
          placeholder="Filter by flag"
          value={featureFilter}
          canClear
          valueAsId
          onChange={onFeatureFilterChange}
        />
      )}
      {canFilterByCompany && (
        <CompanyAutocompleteSelect
          placeholder="Filter by company"
          value={companyFilter}
          canClear
          valueAsId
          onChange={onCompanyFilterChange}
        />
      )}
      {canFilterBySegment && (
        <SegmentPicker
          includeAll={false}
          placeholder="Filter by segment"
          value={segmentFilter}
          canClear
          onChange={onSegmentFilterChange}
        />
      )}
    </Flex>
  );
};
